import { FC, PropsWithChildren, ImgHTMLAttributes } from 'react';
import { Box, styled, SxProps } from '@mui/material';
import { colors } from 'assets/styles/AMBGTheme';
import { StyledAuthContainer } from 'assets/styles/Common.style';
import AMBGLogo from 'assets/images/ambg-logo.png';
interface IProps extends PropsWithChildren {}

const layoutStyles = { width: '100%', height: '100vh', display: 'flex' } as SxProps;
const formWrapperStyles = {
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: colors.secondary.shade4,
	padding: '20px'
} as SxProps;

export const StyledImg: FC<ImgHTMLAttributes<HTMLImageElement>> = styled('img')({
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	verticalAlign: 'bottom'
});

const PublicLayout: FC<IProps> = (props) => {
	return (
		<Box sx={layoutStyles}>
			<Box sx={formWrapperStyles}>
				<StyledAuthContainer variant='outlined'>
					<Box sx={{ height: '70px' }}>
						<img alt='ambg logo' src={AMBGLogo} style={{ height: '100%' }} data-testid='ambgLogo' />
					</Box>
					{props.children}
				</StyledAuthContainer>
			</Box>
		</Box>
	);
};

export default PublicLayout;
